class SaveIdentityProvider {
	constructor(
		public readonly accountId: number,
		public readonly mode: string,
		public readonly isEnabled: boolean,
		public readonly issuerUrl: string,
		public readonly clientId: string,
		// Blank means "leave the registered secret untouched": the server never re-serves it (SEC-12),
		// so an edit form has no value to send back unless the administrator types a new one.
		public readonly clientSecret: string,
		public readonly emailDomains: readonly string[],
	) {
		Object.freeze(this);
	}

	// `accountId` is the route identifier: it must never be echoed in the request body.
	// `clientSecret` is sent as a bare value (`'coexistence'`-style asymmetry does not apply here, but
	// the omission rule does): an empty value means "keep the existing secret", so the KEY itself is
	// omitted rather than sent as `''` (fails `@IsNotEmpty()`) or `null` (fails `@IsOptional()`).
	toJSON(): Record<string, unknown> {
		const body: Record<string, unknown> = {
			mode: this.mode,
			isEnabled: this.isEnabled,
			issuerUrl: this.issuerUrl,
			clientId: this.clientId,
			emailDomains: this.emailDomains,
		};

		if (this.clientSecret !== '') {
			body.clientSecret = this.clientSecret;
		}

		return body;
	}
}

export default SaveIdentityProvider;
